import { FC } from 'react';
import Button from '../../../../../../components/common/Button';
import styles from './styles.module.css';

type Props = {
  disabledOnNext?: boolean;
  onNext: () => void;
  onBack?: () => void;
  onNextLabel?: string;
  onBackLabel?: string;
};
/**
 * フッター UI としては FooterControl が既に存在するが
 * あちらは配車計算状況のポップアップがセットであるのでフッターだけのものをモーダル用に作成する
 */
const ModalFooter: FC<Props> = ({
  disabledOnNext,
  onNext,
  onBack,
  onNextLabel = '次へ',
  onBackLabel = '戻る',
}) => {
  return (
    <div className={styles.footer}>
      {onBack && (
        <div className={styles.button}>
          <Button onClick={onBack} variants={['cancel', 'fit']}>
            {onBackLabel}
          </Button>
        </div>
      )}
      <div className={styles.button}>
        <Button onClick={onNext} variants={['fit']} disabled={disabledOnNext}>
          {onNextLabel}
        </Button>
      </div>
    </div>
  );
};

export default ModalFooter;
